export enum Redirect {
  Default = 'default',
  Web = 'web',
  Deepview = 'deepview',
}
